import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientBankAccountsApiAdapter } from '../adapters/ClientBankAccountsApiAdapter';

export const useClientBankAccounts = (teamId: number) => {
    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientBankAccountsApiAdapter(httpClient);
    }, []);

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['client-bank-accounts', teamId],
        queryFn: async () => {
            const response = await apiAdapter.getBankAccountsByTeamId(teamId);
            return response;
        },
        staleTime: 2 * 60 * 1000,
        enabled: !!teamId,
    });

    return {
        bankAccounts: data?.data ?? [],
        total: data?.meta?.total ?? 0,
        isLoading,
        error,
        refetch,
    };
};

